import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Image } from '@thd-olt-component-react/core-ui';
import styles from './fieldset.module.scss';

let cx = classNames.bind(styles);

const Fieldset = ({
  iconUrl, title, children, border, borderColor
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('fieldset.ready'); }, []);

  return (
    <fieldset
      className={cx('thdFieldset', { border })}
      style={{ borderColor }}
    >
      <legend className={cx('thdFieldset__legend')}>
        { iconUrl
            && (
              <Image
                src={iconUrl}
                alt=""
                height="30"
                width="30"
                className={cx('thdFieldset__icon')}
                role="presentation"
              />
            )}
        <h3 className={cx('thdFieldset__title')}>{ title }</h3>
      </legend>
      <div>
        { children }
      </div>
    </fieldset>
  );
};

Fieldset.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]).isRequired,
  iconUrl: PropTypes.string,
  border: PropTypes.bool,
  borderColor: PropTypes.string
};

Fieldset.defaultProps = {
  iconUrl: '',
  border: true,
  borderColor: styles.lightColor
};

Fieldset.displayName = 'Fieldset';

export { Fieldset };
